import {
    Assets,
    Container,
    Graphics,
    Sprite,
    Text,
} from 'pixi.js';
import { SCREEN_HEIGHT, SCREEN_WIDTH, FONT_UI } from '../../GameConst';
import { InfoTextBar } from '../../components/InfoTextBar';
import { StatusWindow } from '../../components/StatusWindow';
import { LayerNameBar } from './LayerNameBar';
import { ScrollBox } from '@pixi/ui';
import { sceneManager } from '../../SceneManager';
import { BattleScene } from '../BattleScene';
import { CommonButton, ON_BUTTON_EVENT } from '../../components/CommonButton';
import { BACK_TOWER_01 } from '../../CommonAssets';

export class FloorSelectLayer extends Container {
    constructor(floors){
        super();

        const background = new Sprite(Assets.get(BACK_TOWER_01.name));
        background.eventMode = 'static';
        this.addChild(background);

        const infoText = new InfoTextBar('対戦相手を選択してください');
        this.addChild(infoText);

        const statusWindow = new StatusWindow();
        this.addChild(statusWindow);

        const layerNameBar = new LayerNameBar('ベリロンタワー', true);
        this.addChild(layerNameBar);

        const scrollBox = new ScrollBox({
            // background: 0XFFFFFF,
            elementsMargin: 10,
            width: SCREEN_WIDTH * 0.8 + 20,
            height: SCREEN_HEIGHT * 0.48,
            radius: 0,
            padding: 10,
            disableEasing: false,
            disableDynamicRendering: true,
        });
        this.addChild(scrollBox);
        scrollBox.x = SCREEN_WIDTH * 0.5 - scrollBox.width * 0.5;
        scrollBox.y = SCREEN_HEIGHT * 0.35;

        const floorUis = [];
        floors.forEach(floor => {
            const floorUi = new Graphics().beginFill(0x000000).drawRect(0, 0, SCREEN_WIDTH * 0.8, SCREEN_HEIGHT * 0.1);
            const floorUiText = new Text(`${floor.floor}F vs ${floor.cpuName} ハイスコア:${floor.maxScore}`, {
                fontFamily: FONT_UI,
                fontSize: SCREEN_HEIGHT * 0.02,
                fill: 'white',
            });
            floorUi.addChild(floorUiText);
            const floorUiButton = new CommonButton(floorUi, {ignorePivot:true});
            floorUiButton.once(ON_BUTTON_EVENT, () => {
                sceneManager.LoadScene(BattleScene, floor);
            });
            floorUis.push(floorUiButton);
        });
        scrollBox.addItems(floorUis.reverse());
    }
}
